import { LISTING_EDIT_MINIMIZED_SOURCE_ID_PREFIX } from './RentalPortalListingsFormModal.constants'

function getIsListingFormDirtyFromOpen() {
  return true
}

export function getListingEditMinimizedSourceId(listingId) {
  return `${LISTING_EDIT_MINIMIZED_SOURCE_ID_PREFIX}${listingId}`
}

export function getIsListingFormDirty({ hasUploadingFiles, isDirtyFromOpen }) {
  return isDirtyFromOpen || hasUploadingFiles
    ? getIsListingFormDirtyFromOpen
    : undefined
}
